export const DEFAULT_WISHLIST_LIMIT = 999999;
